import { render, staticRenderFns } from "./QPill.vue?vue&type=template&id=be2afdfa&scoped=true"
import script from "./QPill.vue?vue&type=script&lang=js"
export * from "./QPill.vue?vue&type=script&lang=js"
import style0 from "./QPill.vue?vue&type=style&index=0&id=be2afdfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2afdfa",
  null
  
)

export default component.exports